export default {
  OPERACION_APARIENCIA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
